import React, { Component } from "react";
import Layout from "../../components/Layout";
import Meta from "../../components/Meta";
import MenuEN from "../../components/en/MenuEN";
import FooterEN from "../../components/en/FooterEN";

class Index extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Layout>
                <Meta
                    title={"Anna Mamchenkova – accounting and management control"}
                    description={"Accountant, expert in management control and profitability: Anna coordinates the files of companies in difficulty."}
                    url={"https://www.coeladvocaten.be/en/anna-mamchenkova"}
                    robots={"index, follow"}
                    languages={[
                        { url:"https://www.coeladvocaten.be/nl/anna-mamchenkova", language:"nl" },
                        { url:"https://www.coeladvocaten.be/fr/anna-mamchenkova", language:"fr" },
                        { url:"https://www.coeladvocaten.be/en/anna-mamchenkova", language:"en" }
                    ]}
                />

                <MenuEN
                    switchUrlNL="/nl/anna-mamchenkova"
                    switchUrlFR="/fr/anna-mamchenkova"
                />

                <div className="page">
                    <div className="header">
                        <div className="grayscale background background-team"></div>
                        <div className="slider">
                            <h1>Our team</h1>
                            <h2>Anna Mamchenkova</h2>
                            <p></p>
                            <a href="/en/contact" alt="contact" className="button">info@coeladvocaten.be</a>
                        </div>
                    </div>

                    <div className="content">
                        <div className="container press">
                            <div className="row">
                                <div className="col-lg-4">
                                    <div className="slider">
                                        <div className="margin-top">
                                            <div className="image">
                                                <img className="img-fluid grayscale team-image-opacity" src="/static/images/ons-team-anna.jpg" width="100%" height="auto" /> 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-8">
                                    <div className="slider">
                                        <div className="margin-top">
                                            <p></p>
                                            <p>Anna Mamchenkova holds a degree in metallurgical engineering and owes her strengths to her initial studies. She is meticulous and examines all the different parameters in each situation before making a decision.</p>
                                            <p>When Anna came to live in Belgium, she studied accounting and management control. Very quickly, her analytical aptitude took over and she realized that her interest lay in accounting tools for:</p>
                                            <p>- carrying out valuations correctly</p>
                                            <p>- carrying out analyzes and diagnoses of financial and operational health</p>
                                            <p>- taking the right decisions in terms of management control</p>
                                            <p>After several years of experience as an accountant and expert in management control, she joined the firm of Coel & Advocaten as head of accounting.</p>
                                            <p>Anna quickly took on new responsibilities and placed her knowledge in accounting and management control at the service of Frank Coel's clients. She helps with the restructuring or recovery plan of companies, with the valuation of a company during a transfer, merger or acquisition, and ensures a smooth process for companies that stop their activities.</p>
                                            <p>Today, Anna Mamchenkova is still the expert in accounting and organization of the law firm. In addition, she also coordinates advice to companies in difficulty.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row"><br /></div>
                        </div>
                    </div>
                </div>

                <FooterEN />
            </Layout>
        );
    }
}

export default Index;
